import { ProofDocumentModal } from 'modules/review/components/ProofDocumentModal';
import { ProofStatus } from 'modules/review/types/proof.type';
import React, { FunctionComponent } from 'react';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { NumberParam, useQueryParam } from 'use-query-params';

type Props = {
  reviewId: number;
  proofStatus?: ProofStatus | null;
  disabled?: boolean;
  onProofChange?: () => void;
};

export const ProofDocumentButton: FunctionComponent<Props> = ({
  reviewId,
  proofStatus,
  disabled = false,
  onProofChange,
}) => {
  const [proofId, setProofId] = useQueryParam('proofId', NumberParam);

  const isOpen = !disabled && proofId === reviewId;

  const isValidated = proofStatus === 'validated';
  const isPending = proofStatus === 'pending';
  const hasProof = Boolean(proofStatus);

  const tooltipContent = hasProof
    ? 'Modifier la preuve de prestation'
    : 'Ajouter une preuve de prestation';

  const getButtonColor = () => {
    if (isValidated) return 'green';
    if (isPending) return 'orange';
    return 'blue';
  };

  const renderIcon = () => {
    if (isValidated) {
      return (
        <Icon.Group>
          <Icon name="file alternate outline" />
          <Icon corner name="check" />
        </Icon.Group>
      );
    }

    if (isPending) {
      return (
        <Icon.Group>
          <Icon name="file alternate outline" />
          <Icon corner name="clock outline" />
        </Icon.Group>
      );
    }

    return (
      <Icon.Group>
        <Icon name="file alternate outline" />
        <Icon corner name="add" />
      </Icon.Group>
    );
  };

  return (
    <>
      <Popup
        content={tooltipContent}
        position="top center"
        trigger={
          <Button
            basic
            icon
            color={getButtonColor()}
            disabled={disabled}
            onClick={() => setProofId(reviewId, 'replaceIn')}
          >
            {renderIcon()}
          </Button>
        }
      />
      <ProofDocumentModal
        open={isOpen}
        reviewId={reviewId}
        onClose={() => setProofId(undefined, 'replaceIn')}
        onProofChange={onProofChange}
      />
    </>
  );
};
